import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { flexRender } from '@tanstack/react-table';

const StyledGrid = styled(Grid)({
  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
});

export default function MobileTable({
  table,
  columnsConfig,
  records,
  onRowClick,
}) {
  function handleOnRowClick(_id) {
    const id = Number(_id);
    if (!id && id !== 0) {
      console.error('Invalid id: ', id);
      return;
    }
    onRowClick({ data: records, id });
  }
  return (
    <Box sx={{ border: '1px solid #C0C0C0', marginTop: '1rem' }}>
      {table.getRowModel().rows.map((row) => {
        return (
          <StyledGrid
            item
            key={row.id}
            onClick={() => handleOnRowClick(row.id)}
            sx={{ borderBottom: '1px solid #C0C0C0', padding: '0.5rem 1rem' }}
          >
            {row.getVisibleCells().map((cell, idx) => {
              return (
                <Grid
                  item
                  key={cell.id}
                  sx={{ display: 'flex', width: '100%', cursor: 'pointer' }}
                >
                  <Box
                    sx={{ maxWidth: '200px', width: '100%', display: 'flex' }}
                  >
                    <p style={{ fontWeight: '600' }}>
                      <Header header={columnsConfig[idx].header} />
                    </p>
                  </Box>
                  <Box sx={{ maxWidth: '500px', width: '100%' }}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </Box>
                </Grid>
              );
            })}
          </StyledGrid>
        );
      })}
    </Box>
  );
}

function Header({ header }) {
  if (typeof header === 'string') {
    return header;
  } else if (typeof header === 'function') {
    return header();
  }
  return null;
}
